import { useState, useEffect } from 'react';
import { FilterCategory, FilterValue, getFilterCategories } from '@/lib/constants';

export const useFilters = () => {
  const [filterCategories, setFilterCategories] = useState<FilterCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        setLoading(true);
        const categories = await getFilterCategories();
        setFilterCategories(categories);
        setError(null);
      } catch (err) {
        setError('Erreur lors du chargement des filtres');
        console.error('Error fetching filters:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFilters();
  }, []);

  const getFilterValuesByCategory = (categoryKey: string): string[] => {
    const category = filterCategories.find(cat => cat.key === categoryKey);
    return category?.filter_values.filter(fv => fv.active).map(fv => fv.value) || [];
  };

  const getFilterCategory = (categoryKey: string): FilterCategory | undefined => {
    return filterCategories.find(cat => cat.key === categoryKey);
  };

  return {
    filterCategories,
    loading,
    error,
    getFilterValuesByCategory,
    getFilterCategory
  };
}; 